import { TAXONOMY_CODES } from '@nesso/practice-contracts/practice-member.models';

// The separator is an en dash (U+2013), not a hyphen — easy to "fix" back when editing this table.
const taxonomyCodeLabels: Record<string, string> = {
    '101YM0800X': '101YM0800X – Mental Health Counselor',
    '101YP2500X': '101YP2500X – Professional Counselor',
    '1041C0700X': '1041C0700X – Clinical Social Worker',
    '1041S0200X': '1041S0200X – School Social Worker',
    '106H00000X': '106H00000X – Marriage and Family Therapist',
    '106S00000X': '106S00000X – Marriage and Family Therapy Intern',
    '103T00000X': '103T00000X – Psychologist',
    '103TC0700X': '103TC0700X – Clinical Psychologist',
    '103TA0400X': '103TA0400X – Addiction (Substance Use) Psychologist',
    '103TB0200X': '103TB0200X – Behavioral Analyst',
    '171M00000X': '171M00000X – Case Manager or Care Coordinator',
    '101Y00000X': '101Y00000X – Counselor (General)',
    '172V00000X': '172V00000X – Clinical Neuropsychologist',
    '225C00000X': '225C00000X – Rehabilitation Counselor',
    '225XR0403X': '225XR0403X – Rehabilitation Practitioner Mental Health',
    '101YA0400X': '101YA0400X – Addiction Counselor',
    '103TA0700X': '103TA0700X – Counseling Psychologist',
    '103TP0016X': '103TP0016X – Prescribing Psychologist',
    '363LP0808X': '363LP0808X – Psychiatric Mental Health Nurse Practitioner',
    '364SP0808X': '364SP0808X – Psychiatric Mental Health Clinical Nurse Specialist',
    '104100000X': '104100000X – Social Worker (General)',
    '101YP1600X': '101YP1600X – Pastoral Counselor',
};

export const taxonomyCodeOptions = TAXONOMY_CODES.map((value) => ({
    value,
    label: taxonomyCodeLabels[value] ?? value,
}));

export function getTaxonomyCodeLabel(value: string): string {
    return taxonomyCodeLabels[value] ?? value;
}
